import {createSlice} from "@reduxjs/toolkit";

import {lookupAddressByPostcode} from "http/addresses";
import {startLoading, loadingFailed} from "store/helpers/actions";
import {extractError} from "store/helpers";
import {logout} from "store/auth/actions";

import initialState, * as handlers from "./handlers";

const {actions, reducer} = createSlice({
  reducers: {
    getAddressByPostCodeRequest: startLoading,
    getAddressByPostCodeSuccess: handlers.getAddressByPostCodeSuccess,
    getAddressByPostCodeFailure: loadingFailed,
  },
  extraReducers: builder => {
    builder.addCase(logout, handlers.clearState);
  },
  initialState,
  name: "addresses",
});

export const getAddressByPostCode = postcode => async dispatch => {
  try {
    dispatch(actions.getAddressByPostCodeRequest());

    const data = await lookupAddressByPostcode(postcode, "GB");

    dispatch(actions.getAddressByPostCodeSuccess(data));
  } catch (error) {
    dispatch(actions.getAddressByPostCodeFailure(extractError(error)));
  }
};

export default reducer;
